module.exports = __webpack_public_path__ + "static/img/about_banner_mobile.8d9524c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_banner_mobile.png
// module id = e4Fm
// module chunks = 1